<div class="form-container">
    <div class="options-container">
        <div class="column">
            <div class="form-group">
                <aum-select
                    placeholder="{{ 'aumico_annual_report_fas_accounts_select_reference_placeholder' | i18next }}"
                    [options]="referenceOptions"
                    [propertyOfOptionId]="'reference'"
                    [propertyOfOptionToDisplay]="'referenceCaption'"
                    [compareWith]="compareSelections"
                    [useIndependentControl]="true"
                    [control]="form.controls['reference']"
                    (selectionChange)="onSelectedReferenceChange($event.value)"
                >
                    <aum-form-field-label>
                        {{ 'aumico_annual_report_fas_select_reference' | i18next }}
                    </aum-form-field-label>
                </aum-select>
            </div>
        </div>
        <div *ngIf="isReferenceOptionSelected">
            <aumico-file-upload
                class="file-upload-container"
                [tint]="true"
                [accept]="'.xls,.xlsx,.XLSX,.XLS'"
                (fileChange)="onFasFileUpload($event)"
                instructionLabelKey="aumico_annual_report_fas_file_upload_instruction_label"
            >
            </aumico-file-upload>
        </div>
    </div>

    <ng-container *ngIf="isReferenceOptionSelected && form != null">
        <div class="row">
            <div class="column aum-typo-paragraph-l">
                {{ 'aumico_annual_report_fas_section_costs_title' | i18next }}
            </div>
        </div>
        <div class="row">
            <div class="column">
                <fixed-assets-schedule-table
                    [tableData]="fixedAssetsScheduleMovements"
                    [balanceOpeningDate]="balanceOpeningDate"
                    [balanceClosingDate]="balanceClosingDate"
                    [noPreviousData]="noPreviousData"
                    [periodStartDate]="periodStartDate"
                    [form]="form"
                    [movements]="movements"
                    tableType="COSTS"
                    [colTitles]="colTitlesTranslation1"
                    [reportLocale]="reportLocale"
                ></fixed-assets-schedule-table>
            </div>
        </div>
        <div class="row">
            <div class="column aum-typo-paragraph-l">
                {{ 'aumico_annual_report_fas_section_depr_title' | i18next }}
            </div>
        </div>

        <div class="row">
            <div class="column">
                <fixed-assets-schedule-table
                    [tableData]="fixedAssetsScheduleMovements"
                    [balanceOpeningDate]="balanceOpeningDate"
                    [balanceClosingDate]="balanceClosingDate"
                    [noPreviousData]="noPreviousData"
                    [periodStartDate]="periodStartDate"
                    [form]="form"
                    [movements]="movements"
                    tableType="DEPRECIATION"
                    [colTitles]="colTitlesTranslation2"
                    [reportLocale]="reportLocale"
                ></fixed-assets-schedule-table>
            </div>
        </div>

        <div class="row">
            <div class="column aum-typo-paragraph-l">
                {{ 'aumico_annual_report_fas_section_valAppr_title' | i18next }}
            </div>
        </div>

        <div class="row">
            <div class="column">
                <fixed-assets-schedule-table
                    [tableData]="fixedAssetsScheduleMovements"
                    [balanceOpeningDate]="balanceOpeningDate"
                    [balanceClosingDate]="balanceClosingDate"
                    [noPreviousData]="noPreviousData"
                    [periodStartDate]="periodStartDate"
                    [form]="form"
                    [movements]="movements"
                    tableType="VALUE APPRECIATION"
                    [colTitles]="colTitlesTranslation3"
                    [reportLocale]="reportLocale"
                ></fixed-assets-schedule-table>
            </div>
        </div>
    </ng-container>
</div>
